import { isNullOrEmpty } from './StringHelpers';

export function getNestedValue(obj, key) {
  return key.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : null), obj);
}

export const styledNumber = (number) => {
  return `<span class='no-wrap'>${number?.replace(/^(.{3})(.*)$/, '$1-$2')}</span>`;
};

export function replacePlaceholders(template, data, removeBr, placeHolderFunctions = null) {
  // data = state, template = title string with placeholders
  // title = "Hello {user.name}, your phone number is {user.phone}"

  if(isNullOrEmpty(data)) {
    return template;
  }

  if (placeHolderFunctions) {
    template = template.replace(/{([\w.]+)}/g, (match, key) => {
      return placeHolderFunctions[key]?(placeHolderFunctions[key](data)):match;
    });
  }
  if (removeBr) {
    template = template.replace(/<br\s*\/?>/gi, ''); // Remove all <br> tags if removeBr is true
  }

  return template.replace(/{([\w.]+)}/g, (match, key) => {
    const value = getNestedValue(data, key);
    if (typeof value === 'string' && value.startsWith('05')) {
      return styledNumber(value);
    }
    return value || match;
  });
}
